import React, { useRef, useState } from 'react';
import Heading from '../../forms/Heading';
import Button from '../../forms/Button';
import CompanyLogo from '../../CompanyLogo';
import Col from '../../layout/Col';
import Img from '../../Img';
import HamQuest from '../../api/HamQuestGiver';
import { QuestRoute } from '../../api/QuestRoutes';
import ModalFactory from '../../Modal';

const Logo = ({ ...props }) => {

    const [newLogo, setNewLogo] = useState('')
    const fileInputRef = useRef(null);

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setNewLogo(URL.createObjectURL(file));
        }
    };

    const handleButtonClick = () => {
        fileInputRef.current.click();
    };

    const removeLogo = () => {
        ModalFactory.confirmAndProcess({
            confirmation: {
                title: `Are you sure?`,
                body: (
                    <Col>
                        <CompanyLogo dim={10} />
                        <p>Are you sure you want to remove your current Logo?</p>
                    </Col>
                ),
                type: 'warning',
            },
            promise: {
                title: 'Removing',
                body: `Removing Logo.`,
                callback: () => HamQuest.delete(QuestRoute.settings.logo)
            },
            confirmed: {
                title: 'Success',
                body: `Logo successfully removed.`,
                type: 'success'
            },
        })
    };

    const saveLogo = () => {
        const file = fileInputRef.current.files[0];
        if (file) {
            const reader = new FileReader();

            reader.onload = function (e) {
                const base64String = e.target.result;
                ModalFactory.confirmAndProcess({
                    confirmation: {
                        title: `Are you sure?`,
                        body: (
                            <Col>
                                <Img src={newLogo} dim={10} />
                                <p>Are you sure you want to update your current Logo?</p>
                            </Col>
                        ),
                        type: 'warning',
                    },
                    promise: {
                        title: 'Updating',
                        body: `Updating Logo.`,
                        callback: () => HamQuest.put(QuestRoute.settings.logo, { logo: base64String })
                    },
                    confirmed: {
                        title: 'Success',
                        body: `Logo successfully updated.`,
                        type: 'success'
                    },
                })
            };

            reader.readAsDataURL(file);
        }
    };

    return (
        <Col>
            <Heading>Logo</Heading>
            {
                newLogo
                    ? <Img src={newLogo} dim={10} />
                    : <CompanyLogo dim={10} />
            }

            <Button
                color={'error'}
                onClick={removeLogo}
                label='Remove Logo'
            />
            <Button
                onClick={handleButtonClick}
                label='Upload New Logo'
            />

            {newLogo && <Button onClick={saveLogo}>Save Changes</Button>}

            <input
                ref={fileInputRef}
                style={{ display: 'none' }}
                type='file'
                accept='image/png, image/jpeg'
                onChange={handleImageChange}
            />
        </Col>
    );
}

export default Logo;